import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledBreadcrumbHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  /* fill the space the parent gives us, and allow shrinking below content width
     so the crumbs can truncate instead of pushing the header wider */
  flex: 1 1 auto;
  min-width: 0;
`;

/**
 * One crumb. Sized by its content but capped at `$maxWidth` (the 40/60 split),
 * so the separator sits right next to short text instead of floating away.
 * Anything longer than the cap truncates.
 */
export const StyledCrumb = styled.div<{ $maxWidth: string }>`
  flex: 0 1 auto;
  min-width: 0;
  max-width: ${({ $maxWidth }) => $maxWidth};

  /* the text lives in the Typo comp, or in the Typo comp inside a link/button
     wrapper — the ellipsis has to land on whichever it is */
  &,
  & > *,
  & > * > * {
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

/**
 * Same width cap for a `node` crumb, but without the truncation cascade — the
 * node owns its own text handling (e.g. an editable title that truncates when
 * idle and scrolls while being edited).
 */
export const StyledNodeCrumb = styled.div<{ $maxWidth: string }>`
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  max-width: ${({ $maxWidth }) => $maxWidth};
`;

export const StyledSeparator = styled.div`
  flex-shrink: 0;
`;

export const StyledCrumbLink = styled(Link)`
  color: inherit;
  text-decoration: none;
`;

/**
 * Typo comps swallow onClick, so a crumb that navigates via a handler (rather
 * than a route) hangs the click on this wrapper instead.
 */
export const StyledCrumbButton = styled.span`
  cursor: pointer;
`;
